export default "__VITE_ASSET__D1Ylp5I3__"